import _ from 'lodash'

export default class CustomAction {
  constructor (options) {
    const obj = _.isPlainObject(options)

    this.action = obj ? _.get(options, 'action') : options
    this.method = obj && _.has(options, 'method') ? _.get(options, 'method') : 'post'
    this.state = obj && _.has(options, 'state') ? _.get(options, 'state') : this.action
  }

  getAction () {
    let action = this.action

    action = action.replace(/:([a-z_]*)/g, '')
    action = _.trim(action, '/')

    return action
  }

  getEndpoint (payload) {
    const regex = /:([a-z_]*)/g
    const found = this.action.match(regex)
    let endpoint = this.action

    if (_.isArray(found)) {
      found.forEach(m => {
        const attr = _.trim(m, ':')
        const value = _.isPlainObject(payload) ? _.get(payload, attr) : payload

        endpoint = endpoint.replace(m, value)
      })
    }

    return endpoint
  }

  getMethod () {
    return this.method.toLowerCase()
  }

  getMutationFormat () {
    return _.camelCase(this.state)
  }

  getMutationStatusFormat () {
    return _.upperFirst(this.getMutationFormat())
  }
}
